import * as React from "react";
import { CustomNodeModel } from "./CustomNodeModel";
import { DiagramEngine, PortWidget } from "@projectstorm/react-diagrams";
import { Tooltip } from "antd";

type StepType = "decision" | "end" | "simple";
export interface CustomNodeWidgetProps {
  node: CustomNodeModel;
  engine: DiagramEngine;
  size?: number;
}

export class CustomNodeWidget extends React.Component<CustomNodeWidgetProps> {
  renderDecisionStep = () => {
    const { node, engine } = this.props;
    const options = node.getOptions();
    const WIDTH = 300;
    const HEIGHT = 100;
    const PORT_HEIGHT = 12; // Height of node square port
    return (
      <div
        style={{
          position: "relative",
          bottom: HEIGHT * 0.25 - PORT_HEIGHT,
          width: WIDTH,
          height: HEIGHT,
        }}
      >
        <svg
          width={WIDTH}
          height={HEIGHT}
          dangerouslySetInnerHTML={{
            __html:
              `
            <g id="Layer_1">
            </g>
            <g id="Layer_2">
              <polygon fill="${
                options.color
              }" stroke="${"#000000"}" stroke-width="2" stroke-miterlimit="10" points="0,` +
              HEIGHT / 2 +
              ` ` +
              WIDTH / 2 +
              `,0 ` +
              WIDTH +
              `,` +
              HEIGHT / 2 +
              ` ` +
              WIDTH / 2 +
              `,` +
              HEIGHT +
              ` "/>
                <text
                    x="${WIDTH / 2}"
                    y="${HEIGHT / 2}"
                    dominant-baseline="middle"
                    text-anchor="middle"
                    font-size="12"
                    fill="#000">
                    ${options.name}
                </text>
            </g>
          `,
          }}
        />
        {node.getPort("In") && (
          <PortWidget
            style={{
              top: HEIGHT / 2,
              left: 15,
              position: "absolute",
            }}
            port={node.getPort("In")}
            engine={engine}
          />
        )}
        {node.getPort("Out") && (
          <PortWidget
            style={{
              right: 0,
              top: HEIGHT / 2,
              position: "absolute",
            }}
            port={node.getPort("Out")}
            engine={engine}
          />
        )}
      </div>
    );
  };

  renderEndStep = () => {
    const { node, engine } = this.props;
    const options = node.getOptions();
    return (
      <div
        className="node-step-container text-center"
        style={{
          width: 80,
          borderRadius: 30,
          backgroundColor: options.color || "#ff0000",
        }}
      >
        <div className="name-wrapper">
          <div>{options.name}</div>
          {node.getPort("In") && (
            <PortWidget
              style={{
                bottom: "50%",
                transform: [{ translateY: "-50%" }],
                left: 0,
                position: "absolute",
              }}
              port={node.getPort("In")}
              engine={engine}
            />
          )}
          {node.getPort("Out") && (
            <PortWidget
              style={{
                bottom: "50%",
                transform: [{ translateY: "-50%" }],
                right: 0,
                position: "absolute",
              }}
              port={node.getPort("Out")}
              engine={engine}
            />
          )}
        </div>
      </div>
    );
  };

  renderSimpleStep = () => {
    const { node, engine } = this.props;
    const options = node.getOptions();
    return (
      <div
        className="node-step-container text-center"
        style={{
          width: 230,
          backgroundColor: options.color || "#fff",
        }}
      >
        <div className="name-wrapper">
          <div>{options.name}</div>
          {node.getPort("In") && (
            <PortWidget
              style={{
                bottom: "50%",
                transform: [{ translateY: "-50%" }],
                left: 0,
                position: "absolute",
              }}
              port={node.getPort("In")}
              engine={engine}
            />
          )}
          {node.getPort("Out") && (
            <PortWidget
              style={{
                bottom: "50%",
                transform: [{ translateY: "-50%" }],
                right: 0,
                position: "absolute",
              }}
              port={node.getPort("Out")}
              engine={engine}
            />
          )}
        </div>
      </div>
    );
  };

  getSepView(type: StepType) {
    const stepMap = {
      simple: this.renderSimpleStep(),
      end: this.renderEndStep(),
      decision: this.renderDecisionStep(),
    };
    return type ? stepMap[type] : stepMap["simple"];
  }

  render() {
    const { node } = this.props;
    const options = node.getOptions();

    return (
      <Tooltip placement="top" title={options.extras?.fullTitle}>
        {this.getSepView(options.extras?.type)}
      </Tooltip>
    );
  }
}
